import Chartist from 'chartist'

export function chartPlugins () {
  Chartist.plugins = Chartist.plugins || {}
  Chartist.plugins.ctBarLabels = function (options) {
    options = Chartist.extend({}, options)

    return function ctBarLabels (chart) {
      if (chart instanceof Chartist.Bar) {

        chart.on('draw', function (data) {
          let barHorizontalCenter, barVerticalCenter, label, value

           if (data.type === 'label'){
              if (isNaN(parseFloat(data.text))) {
                data.element._node.setAttribute('x', data.x + (data.width / 2) - 15);
                data.element.addClass('ct-label-middle');
              }
            }

          if (data.type === 'bar') {

            function sub(val, fullValue) {

             let len = data.y2 - data.y1
             let unit = len / fullValue
             //val*=-1
             data.group.append(new Chartist.Svg('line', {
                  x1: data.x1,
                  y1: data.y1 + (val * unit),
                  x2: data.x1,
                  y2: data.y1+2 + (val * unit),

                }, 'ct-divider'));
            }

            if (window._epxchart.plzMode == true) {
              let fullValue = data.element.attr('ct:value')
              let p = window._epxchart.fixedPrices;
              let f = 1
              if (window._epxchart.isBrutto) {
                f = 1.19
              }
              let c = p.operation * f

              /*
              Energie
              Voltego Zuschlag 
              Umlagen + Steuern 
              Netzkosten
              */

              sub(c, fullValue)
              c+= p.fees_and_taxes * f
              sub(c, fullValue)
              //c+=p.metering
              //sub(c, fullValue)
              c+=p.voltego * f
              sub(c, fullValue)
              
              //sub(p.operation, fullValue)
              //sub(p.metering, fullValue)
              //sub(p.fees_and_taxes, fullValue)
            }

            value = data.element.attr('ct:value')
            //console.log (data)
            data.element._node.setAttribute('ct:index', data.index)
            barHorizontalCenter = data.x1 + (data.element.width() * 0.5)

            if (value < 0) {
              barVerticalCenter = data.y1 + (data.element.height()) + 15
            }
            else {
              barVerticalCenter = data.y1 + (data.element.height() * -1) - 15
            }

            value = Intl.NumberFormat('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(value)

            if (barVerticalCenter < 20) barVerticalCenter = 20;
            //barVerticalCenter = 100;

            if (value !== '0' && value !== '0,00') {
              label = new Chartist.Svg('text')
              label.text(value)
              label.addClass('ct-barlabel')
              label.attr({
                x: barHorizontalCenter,
                y: barVerticalCenter,
                'text-anchor': 'middle',
              })

              return data.group.append(label)
            }
          }
        })
      }
    }
  }

  Chartist.plugins.animateBars = function () {
    return function animateBars (chart) {
      chart.on('draw', function (data) {
        if (data.type == 'bar') {
          data.element.animate({
            y2: {
              dur: '0.5s',
              from: data.y1,
              to: data.y2,
            },
          })
        }
      })
    }
  }

  Chartist.plugins.preventResize = function () {
    return function preventResize (chart) {
      chart.on('created', function () {
        chart.detach() // it will detach resize and media query listeners
      })

      let windowWidthOnPageCall = window.innerWidth
      let timeout

      window.addEventListener('resize', () => {
        clearTimeout(timeout)

        timeout = setTimeout(() => {
          if (window.innerWidth !== windowWidthOnPageCall) {
            windowWidthOnPageCall = window.innerWidth
            chart.update()
          }
        }, 100)
      })
    }
  }

  Chartist.plugins.emptyDataset = function () {
    return function emptyDataset (chart) {
      chart.on('draw', function (data) {
        let notice

        if (chart.data.series[0].length === 0) {
          notice = new Chartist.Svg('text')
          notice.text('Keine Preise vorhanden.')
          notice.addClass('ct-notice')
          notice.attr({
            x: '50%',
            y: '50%',
            'text-anchor': 'middle',
          })

          if (!document.querySelector('.ct-notice')) {
            return data.group.append(notice)
          }
        }
      })
    }
  }



  //-----------------------------------------------------------------

 Chartist.plugins.tooltip = function(options) {

     let defaultOptions = {
        currency: undefined,
        currencyFormatCallback: undefined,
        tooltipOffset: {
          x: 0,
          y: -20,
        },
        anchorToPoint: false,
        appendToBody: true,
        class: undefined,
        pointClass: 'ct-bar',
      };

    options = Chartist.extend({}, defaultOptions, options);


    return function tooltip(chart) {

      //if (window._epxchart.plzMode != true) { 
        //return;
      //} 
      // Warning: If you are using npm link or yarn link, these instanceof checks will fail and you won't any tooltips
      var tooltipSelector = options.pointClass;

      var $chart = chart.container;
      var $toolTipIsShown = false;
      var $tooltipOffsetParent = offsetParent($chart);
      var $toolTip;

      if (!options.appendToBody) {
        // searching for existing tooltip in the chart, because appendToBody is disabled
        $toolTip = $chart.querySelector('.chartist-tooltip');
      } else {
        // searching for existing tooltip in the body, because appendToBody is enabled
        $toolTip = document.querySelector('.chartist-tooltip');
      }
      if (!$toolTip) {
        $toolTip = document.createElement('div');
        $toolTip.className = (!options.class) ? 'chartist-tooltip' : 'chartist-tooltip ' + options.class;
        if (!options.appendToBody) {
          $chart.appendChild($toolTip);
        } else {
          document.body.appendChild($toolTip);
        }
      }
      var height = $toolTip.offsetHeight;
      var width = $toolTip.offsetWidth;

      hide($toolTip);

      function on(event, selector, callback) {
        $chart.addEventListener(event, function (e) {
          if (!selector || hasClass(e.target, selector))
            callback(e);
        });
      }

      on('mouseover', tooltipSelector, function (event) {
        var $point = event.target;
        var tooltipText = 'argel';

        var isPieChart = false;
        var seriesName = (isPieChart) ? $point.parentNode.getAttribute('ct:meta') || $point.parentNode.getAttribute('ct:series-name') : '';
        var meta = $point.getAttribute('ct:meta') || seriesName || '';
        var hasMeta = !!meta;
        var value = $point.getAttribute('ct:value');

        if (options.transformTooltipTextFnc && typeof options.transformTooltipTextFnc === 'function') {
          value = options.transformTooltipTextFnc(value);
        }

        if (options.tooltipFnc && typeof options.tooltipFnc === 'function') {
          tooltipText = options.tooltipFnc(meta, value);
        } else {
          if (options.metaIsHTML) {
            var txt = document.createElement('textarea');
            txt.innerHTML = meta;
            meta = txt.value;
          }

          meta = '<span class="chartist-tooltip-meta">' + meta + '</span>';

          if (hasMeta) {
            tooltipText += meta + '<br>';
          } else {
            // For Pie Charts also take the labels into account
            // Could add support for more charts here as well!
          }

          if (value) {
            if (options.currency) {
              if (options.currencyFormatCallback != undefined) {
                value = options.currencyFormatCallback(value, options);
              } else {
                value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
              }
            }
            tooltipText += value;
          }
        }

        function fmt(val) {
            return Intl.NumberFormat('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(val)
        }

        let p = window._epxchart.fixedPrices;

        let f = 1
        if (window._epxchart.isBrutto) {
          f = 1.19
        }
        let spot = value - (p.operation * f) - (p.metering * f) - (p.fees_and_taxes *f) - (p.voltego * f);

        tooltipText = `<div class="head">${fmt(value)} Cent/kWh</div>
            <div class="table">`

            function add(label, id, value) {
              tooltipText+= `<div>- ${label}</div><div class="p">${fmt(value)}</div>`
            }

            /*
            Energie
            Voltego Zuschlag 
            Umlagen + Steuern 
            Netzkosten
            */

            add("Energie (Spotpreis)", "spot", spot)
            add("Voltego Zuschlag", "voltego", p.voltego * f)
            add("Umlagen & Steuern", "tax", p.fees_and_taxes * f)
            add("Netzkosten", "net", p.operation * f)

            /*
              <div>- Energie (Spotpreis)</div><div class="p">${fmt(spot)}</div>
              <div>- Netzkosten</div><div class="p"> ${fmt(p.operation)}</div>
              <!-- <div>- metering</div><div class="p"> ${p.metering}</div> -->
              <div>- Umlagen & Steuern</div><div class="p">${fmt(p.fees_and_taxes)}</div>
              <div>- Voltego Zuschlag</div><div class="p">${fmt(p.voltego)}</div>
          */ 
          tooltipText+=`</div>`

        tooltipText = '<span class="chartist-tooltip-value">' + tooltipText + '</span>';

        if (tooltipText && window._epxchart.plzMode == true) {
          $toolTip.innerHTML = tooltipText;

          // Calculate new width and height, as toolTip width/height may have changed with innerHTML change
          height = $toolTip.offsetHeight;
          width = $toolTip.offsetWidth;

          if (options.appendToBody !== true) {
            $tooltipOffsetParent = offsetParent($chart);
          }
          if ($toolTip.style.display !== 'absolute') {
            $toolTip.style.display = 'absolute';
          }
          setPosition(event);
          show($toolTip);

          // Remember height and width to avoid wrong position in IE
          height = $toolTip.offsetHeight;
          width = $toolTip.offsetWidth;
        }
      });

      on('mouseout', tooltipSelector, function () {
        hide($toolTip);
      });

      on('mousemove', null, function (event) {
        if (options.anchorToPoint === false && $toolTipIsShown) {
          setPosition(event);
        }
      });

      function setPosition(event) {
        //console.log (event.target.offsetHeight)
        height = height || $toolTip.offsetHeight;
        width = width || $toolTip.offsetWidth;
        var offsetX = -width / 2 + options.tooltipOffset.x;
        var offsetY = -height + options.tooltipOffset.y;

        var anchor = options.anchorToPoint === true && event.target.x2 && event.target.y2;

        if (options.appendToBody === true) {
          if (anchor) {
            var box = $chart.getBoundingClientRect();
            var left = event.target.x2.baseVal.value + box.left + window.pageXOffset;
            var top = event.target.y2.baseVal.value + box.top + window.pageYOffset;

            $toolTip.style.left = left + offsetX + 'px';
            $toolTip.style.top = top + offsetY + 'px';
          } else {
            $toolTip.style.left = event.pageX + offsetX + 'px';
            $toolTip.style.top = event.pageY + offsetY + 'px';
          }
        } else {
          var offsetBox = $tooltipOffsetParent.getBoundingClientRect();
          var allOffsetLeft = -offsetBox.left - window.pageXOffset + offsetX;
          var allOffsetTop = -offsetBox.top - window.pageYOffset + offsetY;

          if (anchor) {
            var box = $chart.getBoundingClientRect();
            var left = event.target.x2.baseVal.value + box.left + window.pageXOffset;
            var top = event.target.y2.baseVal.value + box.top + window.pageYOffset;

            $toolTip.style.left = left + allOffsetLeft + 'px';
            $toolTip.style.top = top + allOffsetTop + 'px';
          } else {
            $toolTip.style.left = event.pageX + allOffsetLeft + 'px';
            $toolTip.style.top = event.pageY + allOffsetTop + 'px';
          }
        }
      }

      /**
       * Shows the tooltip element, if not shown
       * @param element
       */
      function show(element) {
        $toolTipIsShown = true;
        if (!hasClass(element, 'tooltip-show')) {
          element.className = element.className + ' tooltip-show';
        }
      }

      /**
       * Hides the tooltip element
       * @param element
       */
      function hide(element) {
        $toolTipIsShown = false;
        var regex = new RegExp('tooltip-show' + '\\s*', 'gi');
        element.className = element.className.replace(regex, '').trim();
      }

    };
  };

  /**
   * Returns whether a element has a css class called className
   * @param element
   * @param className
   * @return {boolean}
   */
  function hasClass(element, className) {
    return (' ' + element.getAttribute('class') + ' ').indexOf(' ' + className + ' ') > -1;
  }

  function next(element, className) {
    do {
      element = element.nextSibling;
    } while (element && !hasClass(element, className));
    return element;
  }

  /**
   *
   * @param element
   * @return {string | string}
   */
  function text(element) {
    return element.innerText || element.textContent;
  }

  /**
   * Returns the first positioned parent of the element
   * @return HTMLElement
   */
  function offsetParent(elem) {
    if (offsetParent in elem) {
      // Using the native property if possible
      var parent = elem.offsetParent;

      if (!parent) {
        parent = document.body.parentElement;
      }

      return parent;
    }

    var parent = elem.parentNode;
    if (!parent) {
      return document.body.parentElement;
    }

    if (window.getComputedStyle(parent).position !== 'static') {
      return parent;
    } else if (parent.tagName === 'BODY') {
      return parent.parentElement;
    } else {
      return offsetParent(parent);
    }
  }








}
